export default "__VITE_ASSET__14Jv1lqe__"